<template>
  <v-container fluid grid-list-xl>
    <v-form
      ref="form"
      lazy-validation
    >
      <v-layout row wrap>
        <v-flex>
          <v-text-field
            label="Merchant"
            v-model="merchant"
            box
            hide-details
          ></v-text-field>
        </v-flex>

        <v-flex>
          <v-textarea
            v-model="request"
            label="Request"
            auto-grow
            box
          ></v-textarea>
        </v-flex>
        <v-flex>
          <v-textarea
            v-model="response"
            label="Response"
            auto-grow
            box
          ></v-textarea>
        </v-flex>
      </v-layout>

      <v-divider class="primary"></v-divider>

      <v-layout row wrap justify-end>
        <v-btn color="primary" @click="search">Search</v-btn>
      </v-layout>
    </v-form>

    <v-layout row wrap>
      <v-flex xs6>
        Local:
        <VueJsonPrettyWrapper :data="transactionLocal"></VueJsonPrettyWrapper>
      </v-flex>
      <v-flex xs6>
        Remote:
        <VueJsonPrettyWrapper :data="transactionRemote"></VueJsonPrettyWrapper>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import VueJsonPrettyWrapper from '@/components/VueJsonPrettyWrapper.vue'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  components: {VueJsonPrettyWrapper},

  data: function () {
    return {
      merchant: '',
      response: '',
      request: ''
    }
  },

  methods: {
    async search () {
      try {
        Bus.$emit('openWaitModal')

        let result = await this.api({
          method: 'get',
          url: '/trxservices',
          params: {
            merchant: '',
            request: ''
          }
        })

        console.log(result)
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/trxservices/Query.vue